import { apiGet } from './client';

/**
 * Phase 71 (VAC-01..05/07, D-08) — HR-only vacation balance read client,
 * matching backend/src/api/routes/vacationBalance.ts (requireHR-gated).
 *
 * All four figures are nullable together: a user with no active
 * employee-category (HPP) relationship for the requested year has no
 * entitlement/limit at all (VAC-04) — the UI must render "no entitlement
 * (contractor)" rather than a zero balance in that case.
 */
export interface VacationBalance {
  year: number;
  entitlementHours: number | null;
  usedHours: number | null;
  carriedInHours: number | null;
  remainingHours: number | null;
}

export async function getVacationBalance(userId: number, year: number): Promise<VacationBalance> {
  const res = await apiGet<{ data: VacationBalance }>(
    `/admin/users/${userId}/vacation-balance?year=${year}`
  );
  return res.data;
}
